export default function Notification() {
  return (
    <>
      <div className="screen active" id="screen-notifications">
        <div className="page-head">
          <div>
            <h1>Notifications</h1>
            <div className="ph-sub">
              Due bills, fund updates and system notices
            </div>
          </div>
          <div className="page-actions">
            <button className="btn btn-ghost btn-sm" onclick="markAllRead()">
              Mark all as read
            </button>
          </div>
        </div>
        <div className="card">
          <div id="notif-list">
            <div
              className="check-row"
              style={{ alignItems: "flex-start", marginBottom: 10 }}
              onclick="readNotif(0)"
            >
              <div
                className="tx-ico"
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 11,
                  background: "var(--surface-3)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 8v5M12 16h.01"
                    stroke="#B57A00"
                    strokeWidth={2}
                    strokeLinecap="round"
                  />
                  <circle
                    cx={12}
                    cy={12}
                    r={9}
                    stroke="#B57A00"
                    strokeWidth="1.6"
                  />
                </svg>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: "12.5px", fontWeight: 700 }}>
                  6 bills due this week across 4 billers
                </div>
                <div
                  style={{
                    fontSize: "10.5px",
                    color: "var(--text-faint)",
                    marginTop: 3,
                  }}
                >
                  2 hours ago
                </div>
              </div>
              <div
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: "var(--violet)",
                  marginTop: 4,
                }}
              />
            </div>
            <div
              className="check-row"
              style={{ alignItems: "flex-start", marginBottom: 10 }}
              onclick="readNotif(1)"
            >
              <div
                className="tx-ico"
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 11,
                  background: "var(--surface-3)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 5v14M5 12h14"
                    stroke="#0096D6"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: "12.5px", fontWeight: 700 }}>
                  Fund request FR-88250 is pending verification
                </div>
                <div
                  style={{
                    fontSize: "10.5px",
                    color: "var(--text-faint)",
                    marginTop: 3,
                  }}
                >
                  5 hours ago
                </div>
              </div>
              <div
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: "var(--violet)",
                  marginTop: 4,
                }}
              />
            </div>
            <div
              className="check-row"
              style={{ alignItems: "flex-start", marginBottom: 10 }}
              onclick="readNotif(2)"
            >
              <div
                className="tx-ico"
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 11,
                  background: "var(--surface-3)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 13l4 4L19 7"
                    stroke="#11905F"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: "12.5px", fontWeight: 700 }}>
                  Payment to HDFC Bank FASTag (₹5,000) was successful
                </div>
                <div
                  style={{
                    fontSize: "10.5px",
                    color: "var(--text-faint)",
                    marginTop: 3,
                  }}
                >
                  Yesterday
                </div>
              </div>
              <div
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: "var(--violet)",
                  marginTop: 4,
                }}
              />
            </div>
            <div
              className="check-row"
              style={{ alignItems: "flex-start", marginBottom: 10 }}
              onclick="readNotif(3)"
            >
              <div
                className="tx-ico"
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 11,
                  background: "var(--surface-3)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
                  <path
                    d="M4 10h16M4 10v8h16v-8M4 10l8-6 8 6"
                    stroke="#00A88C"
                    strokeWidth="1.6"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: "12.5px", fontWeight: 500 }}>
                  Refund of ₹2,999 processed for failed Jio Postpaid transaction
                </div>
                <div
                  style={{
                    fontSize: "10.5px",
                    color: "var(--text-faint)",
                    marginTop: 3,
                  }}
                >
                  2 days ago
                </div>
              </div>
            </div>
            <div
              className="check-row"
              style={{ alignItems: "flex-start", marginBottom: 10 }}
              onclick="readNotif(4)"
            >
              <div
                className="tx-ico"
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 11,
                  background: "var(--surface-3)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
                  <circle
                    cx={12}
                    cy={12}
                    r={9}
                    stroke="#7C8BA3"
                    strokeWidth="1.6"
                  />
                  <path
                    d="M12 8v4l3 2"
                    stroke="#7C8BA3"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: "12.5px", fontWeight: 500 }}>
                  Scheduled maintenance completed successfully
                </div>
                <div
                  style={{
                    fontSize: "10.5px",
                    color: "var(--text-faint)",
                    marginTop: 3,
                  }}
                >
                  4 days ago
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
